import React from "react";
import NotSet from "./NotSet";

interface TextOrNotSetProperties {
    value?: string|number|null;
}
const TextOrNotSet: React.FC<TextOrNotSetProperties> = ({value})=>{
    return (
        <React.Fragment>
            {value === undefined || value === "" || value === null
                ? <NotSet />
                : value}
        </React.Fragment>
    );
}
export default TextOrNotSet;